import React, { useEffect, useState } from 'react';
import { MenuIcon, X } from 'lucide-react';
export function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`} data-id="element-237">
      <div className="container mx-auto px-4 py-4" data-id="element-238">
        <div className="flex justify-between items-center" data-id="element-239">
          <div className="flex items-center" data-id="element-240">
            <a href="/" className="flex items-center" data-id="element-241">
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/r4ghx198qvioniuadphfqh/81449d38-4222-488a-b12b-9f20b25eda97/logo.jpg" alt="She Wins International Ministry" className="h-16 w-auto md:h-20" data-id="element-242" />
            </a>
          </div>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8" data-id="element-243">
            <NavLink href="#home" isScrolled={isScrolled} data-id="element-244">
              Home
            </NavLink>
            <NavLink href="#about" isScrolled={isScrolled} data-id="element-245">
              About Us
            </NavLink>
            <NavLink href="#programs" isScrolled={isScrolled} data-id="element-246">
              Programs
            </NavLink>
            <NavLink href="#community" isScrolled={isScrolled} data-id="element-247">
              Community
            </NavLink>
            <NavLink href="#blog" isScrolled={isScrolled} data-id="element-248">
              Blog
            </NavLink>
            <NavLink href="#media" isScrolled={isScrolled} data-id="element-249">
              Media
            </NavLink>
            <NavLink href="#contact" isScrolled={isScrolled} data-id="element-250">
              Contact
            </NavLink>
          </nav>
          {/* Mobile Menu Button */}
          <button className={`md:hidden focus:outline-none ${isScrolled ? 'text-gray-700 hover:text-pink-600' : 'text-white hover:text-pink-300'}`} onClick={toggleMenu} data-id="element-251">
            {isMenuOpen ? <X size={24} data-id="element-252" /> : <MenuIcon size={24} data-id="element-253" />}
          </button>
        </div>
      </div>
      {/* Mobile Menu */}
      {isMenuOpen && <div className="md:hidden bg-white shadow-lg" data-id="element-254">
          <div className="container mx-auto px-4 py-4" data-id="element-255">
            <div className="flex flex-col space-y-4" data-id="element-256">
              <MobileNavLink href="#home" onClick={toggleMenu} data-id="element-257">
                Home
              </MobileNavLink>
              <MobileNavLink href="#about" onClick={toggleMenu} data-id="element-258">
                About Us
              </MobileNavLink>
              <MobileNavLink href="#programs" onClick={toggleMenu} data-id="element-259">
                Programs
              </MobileNavLink>
              <MobileNavLink href="#community" onClick={toggleMenu} data-id="element-260">
                Community
              </MobileNavLink>
              <MobileNavLink href="#blog" onClick={toggleMenu} data-id="element-261">
                Blog
              </MobileNavLink>
              <MobileNavLink href="#media" onClick={toggleMenu} data-id="element-262">
                Media
              </MobileNavLink>
              <MobileNavLink href="#contact" onClick={toggleMenu} data-id="element-263">
                Contact
              </MobileNavLink>
            </div>
          </div>
        </div>}
    </header>;
}
function NavLink({
  href,
  children,
  isScrolled
}) {
  return <a href={href} className={`font-medium transition-colors duration-200 ${isScrolled ? 'text-gray-700 hover:text-pink-600' : 'text-white hover:text-pink-300'}`} data-id="element-264">
      {children}
    </a>;
}
function MobileNavLink({
  href,
  children,
  onClick
}) {
  return <a href={href} className="text-gray-700 hover:text-pink-600 font-medium py-2 transition-colors duration-200" onClick={onClick} data-id="element-265">
      {children}
    </a>;
}